<template>
  <v-container class="py-10">
    <!-- Título -->
    <v-row justify="center" class="mb-6">
      <v-col cols="12" md="8" class="text-center">
        <h2 class="display-1 font-weight-bold">Nueva consulta de Personas</h2>
        <p class="subtitle-1 grey--text">
          Ingresa los siguientes datos para validar la identidad de la persona física que deseas consultar.
        </p>
      </v-col>
    </v-row>

    <!-- Formulario -->
    <v-form ref="form" v-model="valid" v-if="!bLoading">
      <v-card class="pa-6 mx-6" style="box-shadow: 0 4px 12px rgba(0, 0, 0, 0.38); border-radius: 16px;">
        <v-row>
          <v-col cols="12" md="5" style="justify-content: center;">
            <h3 class="font-weight-bold">Ingresa los siguientes datos para realizar la búsqueda:</h3>
            <v-divider class="my-4"></v-divider>

            <h4 class="font-weight-bold">Instrucciones para Generar un Reporte de Personas</h4>

            <p class="font-weight-bold mt-4">Paso 1: Ingresar los datos generales de la persona</p>
            <ul>
              <li>Si no cuenta con el CURP, completa manualmente los datos generales.</li>
              <li>Si la persona no tiene Apellido Materno, escribe <span class="red--text font-weight-bold">"XXX"</span> en ese campo.</li>
            </ul>


            <p class="font-weight-bold mt-4">Paso 2: Ingresar los datos opcionales</p>
            <ul>
            <li>Para validar identidad digital, ingresa teléfono, correo electrónico o ambos.</li>
            <li>Para validar la credencial del INE, carga las imágenes de frente y reverso.</li>
            </ul>
          </v-col>
          <v-col cols="12" md="7">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.curp" rounded hide-details label="CURP (opcional)" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.nombres" rounded hide-details label="Nombre(s)*" outlined dense required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.apellidoPaterno" rounded hide-details label="Apellido Paterno*" outlined dense required></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.apellidoMaterno" rounded hide-details label="Apellido Materno*" outlined dense required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="['HOMBRE', 'MUJER']"
                  label="Sexo*"
                  outlined
                  dense
                  v-model="form.sexo"
                  rounded hide-details
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="estados"
                  label="Estado de Nacimiento*"
                  outlined
                  v-model="form.estadoNacimiento"
                  dense
                  required
                  rounded hide-details
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.fechaNacimiento"
                      label="Fecha de Nacimiento*"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      rounded hide-details
                      v-on="on"
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.fechaNacimiento" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.rfc" rounded hide-details label="RFC (opcional)" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Teléfono Celular (opcional)"
                  prepend-inner="(+52) México"
                  outlined
                  v-model="form.telefono"
                  rounded hide-details
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.correoElectronico" rounded hide-details label="Correo Electrónico (opcional)" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-file-input
                  label="Frente de INE"
                  outlined
                  rounded hide-details
                  dense
                  v-model="form.frenteIne"
                  prepend-icon=""
                  prepend-inner-icon="mdi-cloud-upload"
                  show-size
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                  label="Reverso de INE"
                  outlined
                  v-model="form.reversoIne"
                  rounded hide-details
                  dense
                  prepend-icon=""
                  prepend-inner-icon="mdi-cloud-upload"
                  show-size
                ></v-file-input>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <v-row justify="center" class="mt-6">
        <v-btn color="white" class="mr-4" elevation="2" style="border: 2px solid #193D6E;" rounded @click="cancelar">
          <span class="font-weight-bold">Cancelar</span>
        </v-btn>
        <v-btn color="#193D6E" dark class="px-8 white--text" rounded @click="enviarFormularioPersona()">
          Siguiente
        </v-btn>
      </v-row>
    </v-form>
    <v-container v-else class="text-center">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
      <p class="mt-4">Cargando...</p>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'ConsultaPersonaForm',
  data() {
    return {
      valid: false,
      bLoading: false,
      menu: false,
      form: {
        curp: '',
        nombres: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        sexo: '',
        estadoNacimiento: '',
        fechaNacimiento: '',
        telefono: '',
        rfc: '',
        correoElectronico: '',
        frenteIne: null,
        reversoIne: null,
      },
      estados: [
        'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Chiapas', 'Chihuahua', 'CDMX', 'Coahuila', 'Colima', 'Durango',
        'Estado de México', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco',
        'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla',
        'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
      ],
      rules: {
        required: value => !!value || 'Este campo es obligatorio',
      },
    };
  },
  methods: {
    cancelar() {
      this.$router.push('/securityAgent'); // O ruta que desees
      
    },
    async enviarFormularioPersona() {
      if (this.$refs.form.validate()) {
        this.bLoading = true;
        try {
          const formData = new FormData();
          formData.append("curp", this.form.curp);
          formData.append("nombres", this.form.nombres);
          formData.append("apellidoPaterno", this.form.apellidoPaterno);
          formData.append("apellidoMaterno", this.form.apellidoMaterno);
          formData.append("sexo", this.form.sexo);
          formData.append("telefono", this.form.telefono);
          formData.append("estadoNacimiento", this.form.estadoNacimiento);
          formData.append("fechaNacimiento", this.form.fechaNacimiento);
          formData.append("rfc", this.form.rfc);
          formData.append("correoElectronico", this.form.correoElectronico);
          formData.append("frenteIne", this.form.frenteIne);
          formData.append("reversoIne", this.form.reversoIne);


          const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/check/persona/consultar`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            },
          });

          this.$router.push(`/reportPerson/${response.data.data.sId}`);
        } catch (error) {
          console.error("Error al enviar formulario:", error);
          this.mixError(error.response?.data?.message || "Ocurrió un error");
        } finally {
          this.bLoading = false;
        }
      }
    },
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.landing[this.selectLanguage];
      }
    },
  },
};
</script>
